<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" class="tabs">
        <el-tab-pane :label="item.label" v-for="item in tables" :key="item.value" :name="item.value">
          <div slot="label">
            <span>{{ item.label }}</span>
            <el-badge :value="item.number" v-if="item.number"></el-badge>
          </div>
        </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent" @getNumber="getNumber"></component>
    </content-panel>
  </div>
</template>

<script>
import ToBeProcessed from './to-be-processed/ToBeProcessed';
import CannotProcess from './cannot-process/CannotProcess';
import Processing from './processing/Processing';
import AlreadyProcessed from './already-processed/AlreadyProcessed';
import Obsoleted from './obsoleted/Obsoleted';
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'FastProductArrival1',
  mixins: [pagePathMixin],
  components: { ToBeProcessed, CannotProcess, Processing, AlreadyProcessed, Obsoleted },
  data() {
    return {
      activeName: 'ToBeProcessed',
      tables: [
        {
          value: 'ToBeProcessed',
          label: '待处理',
          number: '',
        },
        {
          value: 'CannotProcess',
          label: '暂缓处理',
          number: '',
        },
        {
          value: 'Processing',
          label: '已处理',
          number: '',
        },
        {
          value: 'AlreadyProcessed',
          label: '未上架',
          number: '',
        },
        {
          value: 'Obsoleted',
          label: '已作废',
          number: '',
        },
      ],
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
    let query = this.$route.query;
    if (query.parentTab) {
      this.activeName = query.parentTab;
    }
    this.$store.dispatch('menu/getMenusNum', {}, { root: true });
    this.getNumber();
  },
  methods: {
    getNumber() {
      this.$q.newProduct.waiteAndNotStatics().then((res) => {
        this.tables[0].number = res.data.waiteQty;
        this.tables[1].number = res.data.cannotQty;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
  >>> .el-badge
        left -4px
  >>> .el-badge__content
        background-color #f56c6c
</style>
